import React from 'react';
import * as Icons from 'lucide-react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { methodologies, services, kccOffers } from '../mock/data';

const Mentors = () => {
  const successHighlights = [
    { src: '/assets/successes/toppers.jpg', alt: 'Topper highlights' },
    { src: '/assets/successes/results.jpg', alt: 'Results highlights' },
    { src: '/assets/successes/JeeAdvResult.jpg', alt: 'JEE Advanced results' },
    { src: '/assets/successes/jeemainres.jpg', alt: 'JEE Main results' },
    { src: '/assets/successes/mainsres2.jpg', alt: 'JEE Main results (2)' },
    { src: '/assets/successes/advres2.jpg', alt: 'JEE Advanced results (2)' },
    { src: '/assets/successes/advres3.jpg', alt: 'JEE Advanced results (3)' },
    { src: '/assets/successes/Srijit.jpg', alt: 'Student success: Srijit' },
    { src: '/assets/successes/Aditri.jpg', alt: 'Student success: Aditri' },
    { src: '/assets/successes/Koyena.jpg', alt: 'Student success: Koyena' },
    { src: '/assets/successes/Manami.jpg', alt: 'Student success: Manami' },
    { src: '/assets/successes/Oishi.jpg', alt: 'Student success: Oishi' }
  ];

  const weeklyWins = Array.from({ length: 16 }, (_, i) => ({
    src: `/assets/successes/weeklywins/${i + 1}.jpg`,
    alt: `Weekly win ${i + 1}`
  }));

  return (
    <div className="min-h-screen bg-offwhite text-navy">
      {/* Hero Section */}
      <section className="pt-28 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <Badge className="bg-navy text-offwhite border-0 px-4 py-1.5 text-sm">
                Popular Chemistry Faculty
              </Badge>
              <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-navy">
                Tapas Kumar <span className="text-electric">Koley</span>
              </h1>
              <p className="text-xl sm:text-2xl text-navy/70 font-medium">
                Ex-FIITJEE, Ex-AAKASH
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center space-x-3 bg-white border border-navy/10 rounded-full px-4 py-2">
                  <div className="w-2.5 h-2.5 bg-electric rounded-full" />
                  <span className="text-navy/70">PG @Delhi University</span>
                </div>
                <div className="flex items-center space-x-3 bg-white border border-navy/10 rounded-full px-4 py-2">
                  <div className="w-2.5 h-2.5 bg-electric rounded-full" />
                  <span className="text-navy/70">Mentored 2000+ engineering aspirants & 400+ medical aspirants</span>
                </div>
                <div className="flex items-center space-x-3 bg-white border border-navy/10 rounded-full px-4 py-2">
                  <div className="w-2.5 h-2.5 bg-teal rounded-full" />
                  <span className="text-navy/70">95% Success Rate</span>
                </div>
              </div>
              
              {/* Achievement Stats */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                <div className="bg-white border border-navy/10 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-electric">18</div>
                  <div className="text-sm text-navy/70">Years Exp.</div>
                </div>
                <div className="bg-white border border-navy/10 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-electric">500+</div>
                  <div className="text-sm text-navy/70">Top Ranks</div>
                </div>
                <div className="bg-white border border-navy/10 rounded-xl p-4 text-center">
                  <div className="text-3xl font-bold text-teal">95%</div>
                  <div className="text-sm text-navy/70">Success</div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="relative bg-white border border-navy/10 rounded-2xl p-6">
                <img
                  src="/assets/tkkoley.png"
                  alt="Tapas Kumar Koley"
                  className="w-full rounded-2xl"
                />
                {/* Floating achievement badge */}
                <div className="absolute top-4 right-4 bg-electric rounded-full p-3 border border-navy/10">
                  <Icons.Award className="w-6 h-6 text-offwhite" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy mb-4">
              About <span className="text-electric">T.K.Koley</span>
            </h2>
          </div>
          <Card className="bg-white border border-navy/10 p-8 md:p-12">
            <p className="text-navy/70 text-lg leading-relaxed">
              Tapas Kumar Koley is a renowned figure in the field of Chemistry, who has pursued his Masters at Delhi University in Chemistry. With 18 years of experience in teaching Chemistry, he has been in FIITJEE and AAKASH as Chemistry faculty and instructor. In 2019, he started Koley Chemistry Classes with a very humble vision to provide a launchpad for serious IIT-JEE/NEET aspirants to crack their competitive exam. He has mentored 2000+ engineering aspirants and 400+ medical aspirants. With proven results, he thrives to motivate, inspire and help more students crack their respective competitive exam and secure a seat in their dream college and pursue their passion.
            </p>
          </Card>
        </div>
      </section>

      {/* Methodologies Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy mb-4">
              His Methodologies & Pedagogy
            </h2>
            <p className="text-xl text-navy/70">
              Proven teaching strategies for exam success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {methodologies.map((method, index) => (
              <Card
                key={method.id}
                className="bg-white border border-navy/10 p-6 transition-colors duration-200 hover:border-navy/20"
              >
                <div>
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-semibold text-navy capitalize">
                      {method.title}
                    </h3>
                    <Badge
                      className="bg-offwhite-dark text-navy border border-navy/10"
                    >
                      {method.level}
                    </Badge>
                  </div>
                  <p className="text-navy/70 text-sm leading-relaxed">{method.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy mb-4">
              Services We Provide
            </h2>
            <p className="text-xl text-navy/70">
              Comprehensive support for your exam preparation journey
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => {
              const IconComponent = Icons[service.icon];
              return (
                <Card
                  key={service.id}
                  className="bg-white border border-navy/10 p-6 transition-colors duration-200 hover:border-navy/20"
                >
                  <div className="w-12 h-12 rounded-lg bg-offwhite-dark flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-electric" />
                  </div>
                  <h3 className="text-xl font-semibold text-navy mb-2">
                    {service.title}
                  </h3>
                  <p className="text-navy/70 text-sm leading-relaxed">{service.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* What KCC Offers Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy mb-4">
              What KCC offers to students
            </h2>
            <p className="text-xl text-navy/70">
              From Start to Success
            </p>
          </div>

          <div className="space-y-6">
            {kccOffers.map((offer, index) => (
              <Card
                key={offer.id}
                className="bg-white border border-navy/10 p-6 md:p-8 transition-colors duration-200 hover:border-navy/20"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-electric flex items-center justify-center">
                    <span className="text-offwhite font-bold">{index + 1}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-navy mb-2">
                      {offer.title}
                    </h3>
                    <p className="text-navy/70 leading-relaxed">{offer.description}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Success Gallery Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-navy mb-4">
              Students & <span className="text-electric">Winners</span>
            </h2>
            <p className="text-xl text-navy/70">
              Celebrating the success of our students
            </p>
          </div>

          <div className="space-y-10">
            <div>
              <h3 className="text-lg font-semibold text-navy mb-4">Results & Highlights</h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {successHighlights.map((img) => (
                  <div
                    key={img.src}
                    className="relative overflow-hidden rounded-xl bg-white border border-navy/10"
                  >
                    <a
                      href={img.src}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Open full image"
                      className="block w-full h-full"
                    >
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="w-full h-full aspect-square object-contain bg-offwhite cursor-zoom-in"
                        loading="lazy"
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-navy mb-4">Weekly Wins</h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {weeklyWins.map((img) => (
                  <div
                    key={img.src}
                    className="relative overflow-hidden rounded-xl bg-white border border-navy/10"
                  >
                    <a
                      href={img.src}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Open full image"
                      className="block w-full h-full"
                    >
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="w-full h-full aspect-square object-contain bg-offwhite cursor-zoom-in"
                        loading="lazy"
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mentors;
